<template>
  <div id="app">
    <hhead v-if="showAppHeader" />
    <router-view :key="$route.fullPath" />
  </div>
</template>

<script>
import hhead from '@/components/header/index';
import { shouldShowAppHeader } from '@/utils/appHeader';

export default {
  name: 'App',
  components: { hhead },
  computed: {
    showAppHeader() {
      return shouldShowAppHeader(this.$route);
    },
  },
  created() {
    //设置登录过期时间
    // let storage = localStorage.getItem('loginDate');
    // console.log(storage);
    // if (storage) {
    //   let date = Date.parse(new Date()); //获取登录时间
    //   let day = (date - storage * 1) / 1000 / 60 / 60 / 24; //当前时间减去登录时的时间
    //   console.log(day);
    //   if (day > 7) {
    //     //超过多少天删除
    //     localStorage.removeItem('loginDate');
    //     localStorage.removeItem('token');
    //     this.$router.push('/');
    //   } else {
    //     console.log('未到删除时间');
    //   }
    // }
  },
  watch: {
    $route(to, from) {
      //to:即将要跳转到的页面   from:即将离开的页面
      if (to.path === '/write' && this.$store.state.usertf === '1') {
        this.$router.push('/home');
        this.$emit('denglu');
      } else if (to.path === '/home') {
        this.$router.push('/home');
      }
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/App.vue